module.exports = __webpack_public_path__ + "banner_img3.jpg?cb381163b7beb7f0a03d16cdbe3ca75f";